import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import request from '@/utils/request'
import { useAuthStore } from '@/stores/auth'

const GOLD_AND_ABOVE = ['GOLD_I', 'GOLD_II', 'GOLD_III', 'PLATINUM_I', 'PLATINUM_II', 'PLATINUM_III', 'DIAMOND_I', 'DIAMOND_II', 'DIAMOND_III', 'KING', 'MASTER']
const PLATINUM_AND_ABOVE = ['PLATINUM_I', 'PLATINUM_II', 'PLATINUM_III', 'DIAMOND_I', 'DIAMOND_II', 'DIAMOND_III', 'KING', 'MASTER']
const SILVER_AND_ABOVE = ['SILVER_I', 'SILVER_II', 'SILVER_III', ...GOLD_AND_ABOVE]

export const useRankStore = defineStore('rank', () => {
  const rank = ref(null) // 后端 code，如 BRONZE_I, PLATINUM_II
  const loaded = ref(false)

  const isAtLeastSilver = computed(() => {
    const r = (rank.value || '').toUpperCase()
    return SILVER_AND_ABOVE.includes(r)
  })

  const isAtLeastGold = computed(() => {
    const r = (rank.value || '').toUpperCase()
    return GOLD_AND_ABOVE.includes(r)
  })

  const isAtLeastPlatinum = computed(() => {
    const r = (rank.value || '').toUpperCase()
    return PLATINUM_AND_ABOVE.includes(r)
  })

  const fetchRank = async () => {
    const authStore = useAuthStore()
    if (!authStore.token) {
      rank.value = null
      loaded.value = true
      return
    }
    try {
      const data = await request.get('/achievements/me')
      rank.value = data?.rank || null
    } catch {
      rank.value = null
    } finally {
      loaded.value = true
    }
  }

  const ensureLoaded = async () => {
    if (!loaded.value) await fetchRank()
  }

  const setRankFromAchievements = (achievementsRank) => {
    rank.value = achievementsRank || null
    loaded.value = true
  }

  return {
    rank,
    loaded,
    isAtLeastSilver,
    isAtLeastGold,
    isAtLeastPlatinum,
    fetchRank,
    ensureLoaded,
    setRankFromAchievements
  }
})
